import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Navigation />

      {/* Hero Split-Screen Section */}
      <section className="relative h-screen flex flex-col lg:flex-row">
        {/* Left Half - Blueprint Performance (Dark) */}
        <div className="relative flex-1 bg-gradient-to-br from-[#1a2828] via-[#1a3333] to-[#1a3333] overflow-hidden group">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center opacity-35 group-hover:opacity-45 transition-opacity duration-700"
            style={{
              backgroundImage:
                'url(https://public.readdy.ai/ai/img_res/5068fb791106b1b77f6cb43e83f2d795.jpg)',
            }}
          ></div>

          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

          {/* Content */}
          <div className="relative h-full flex flex-col justify-center px-8 lg:px-16 z-10">
            <div className="max-w-xl">
              <div className="flex items-center space-x-3 mb-6">
                <div className="h-0.5 w-12 bg-[#14B8A6]"></div>
                <span className="text-white/80 text-xs uppercase tracking-[0.3em] font-light">
                  Performance
                </span>
              </div>

              <h2 className="text-7xl lg:text-8xl font-black text-white mb-4 leading-none">
                BLUEPRINT
              </h2>
              <h3 className="text-5xl lg:text-6xl font-black text-white/80 mb-8 leading-none">
                PERFORMANCE
              </h3>

              <p className="text-gray-300 text-base lg:text-lg mb-4 leading-relaxed font-light">
                Engineered Performance through science-backed training programs.
              </p>
              <p className="text-gray-400 text-base lg:text-lg mb-10 leading-relaxed font-light">
                Customized coaching that fits your schedule—results without the hassle.
              </p>

              <Link
                to="/blueprint-performance"
                className="inline-flex items-center space-x-3 bg-black hover:bg-[#14B8A6] text-white px-10 py-5 rounded-full text-sm uppercase tracking-widest font-medium transition-all duration-300 group/btn whitespace-nowrap"
              >
                <span>Enter Blueprint</span>
                <i className="ri-arrow-right-line text-xl group-hover/btn:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* Right Half - Meat Mechanic (Light) */}
        <div className="relative flex-1 bg-gradient-to-br from-[#E8F5F1] via-[#E0F0EB] to-[#D8EBE5] overflow-hidden group">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center opacity-25 group-hover:opacity-35 transition-opacity duration-700"
            style={{
              backgroundImage:
                'url(https://readdy.ai/api/search-image?query=rustic%20culinary%20scene%20with%20fresh%20ingredients%20artisan%20cooking%20preparation%20warm%20natural%20lighting%20wooden%20cutting%20board%20premium%20meat%20cuts%20herbs%20and%20spices%20warm%20seafoam%20and%20aqua%20tones%20simple%20elegant%20food%20styling&width=800&height=1200&seq=mm002&orientation=portrait)',
            }}
          ></div>

          {/* Light Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#E8F5F1]/50 via-[#E8F5F1]/30 to-[#E8F5F1]/60"></div>

          {/* Content */}
          <div className="relative h-full flex flex-col justify-center px-8 lg:px-16 z-10">
            <div className="max-w-xl lg:ml-auto lg:text-right">
              <div className="flex items-center space-x-3 mb-6 lg:justify-end">
                <div className="h-0.5 w-12 bg-[#06B6D4] lg:order-2"></div>
                <span className="text-[#2C5F5F] text-xs uppercase tracking-[0.3em] font-light lg:order-1">
                  Culinary
                </span>
              </div>

              <h2 className="text-7xl lg:text-8xl font-black text-[#1A3A3A] mb-4 leading-none font-serif">
                MEAT
              </h2>
              <h3 className="text-5xl lg:text-6xl font-black text-[#1A3A3A]/70 mb-8 leading-none font-serif">
                MECHANIC
              </h3>

              <p className="text-[#2C5F5F] text-base lg:text-lg mb-4 leading-relaxed">
                Authentic Flavor through artisan recipes and meal prep mastery.
              </p>
              <p className="text-[#4A7373] text-base lg:text-lg mb-10 leading-relaxed">
                Quality meals made simple.
              </p>

              <Link
                to="/meat-mechanic"
                className="inline-flex items-center space-x-3 bg-[#1A3A3A] hover:bg-[#06B6D4] text-white px-10 py-5 rounded-full text-sm uppercase tracking-widest font-medium transition-all duration-300 group/btn whitespace-nowrap"
              >
                <span>Explore Recipes</span>
                <i className="ri-arrow-right-line text-xl group-hover/btn:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 hidden lg:flex flex-col items-center animate-bounce">
          <span className="text-white/60 text-xs uppercase tracking-widest mb-2 font-light">
            Scroll to explore
          </span>
          <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
        </div>
      </section>

      <Footer />
    </div>
  );
}
